export default "__VITE_ASSET__DkYfkxXu__"